import { Link } from 'react-router-dom'
import { HomeIcon } from 'lucide-react'
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { PageHeading } from '@/components/page-heading'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="w-full max-w-md space-y-4 text-center">
        <header className="space-y-2 px-6 pt-6">
          <PageHeading level={1} runLevel={1} className="text-2xl">
            Page Not Found
          </PageHeading>
          <p className="text-muted-foreground text-sm">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </header>
        <CardHeader className="space-y-4">
          <div className="mx-auto w-16 h-16 bg-muted rounded-full flex items-center justify-center">
            <HomeIcon className="w-8 h-8 text-muted-foreground" />
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Don't worry! Let's get you back to the honey show management system.
          </p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button asChild>
            <Link to="/" className="flex items-center space-x-2">
              <HomeIcon className="w-4 h-4" />
              <span>Return home</span>
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
